export const initAliplayer = (
  format: string,
  vid: string,
  playauth: string = '',
  cover = '',

) => {
  if (!document.querySelector('#J_prismPlayer')) return;

  if (format === 'm3u8') {
    // @ts-ignore
    // eslint-disable-next-line no-new
    return new Aliplayer(
      {
        id: 'J_prismPlayer',
        width: '100%',
        height: '100%',
        autoplay: false,
        cover,
        vid,
        playauth,
        format,
        controlBarVisibility: 'hover',
        skinLayout: [
          { name: 'bigPlayButton', align: 'blabs', x: 15, y: 15 },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              {
                name: 'progress',
                align: 'blabs',
                x: 0,
                y: 44,
              },
              {
                name: 'playButton',
                align: 'tl',
                x: 15,
                y: 12,
              },
              {
                name: 'timeDisplay',
                align: 'tl',
                x: 10,
                y: 7,
              },
              {
                name: 'fullScreenButton',
                align: 'tr',
                x: 10,
                y: 12,
              },
              // {
              //   name: 'subtitle',
              //   align: 'tr',
              //   x: 15,
              //   y: 12,
              // },
              // {
              //   name: 'setting',
              //   align: 'tr',
              //   x: 15,
              //   y: 12,
              // },
              {
                name: 'volume',
                align: 'tr',
                x: 5,
                y: 10,
              },
            ],
          },
        ],
      },
      () => {
        console.log('播放器创建成功.');
      }
    );
  } else {
    // @ts-ignore
    // eslint-disable-next-line no-new
    return new Aliplayer(
      {
        id: 'J_prismPlayer',
        source: vid,
        cover,
        width: '100%',
        height: '100%',
        autoplay: false,
        isLive: false,
        controlBarVisibility: 'hover',
        skinLayout: [
          { name: 'bigPlayButton', align: 'blabs', x: 15, y: 15 },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              {
                name: 'progress',
                align: 'blabs',
                x: 0,
                y: 44,
              },
              {
                name: 'playButton',
                align: 'tl',
                x: 15,
                y: 12,
              },
              {
                name: 'timeDisplay',
                align: 'tl',
                x: 10,
                y: 7,
              },
              {
                name: 'fullScreenButton',
                align: 'tr',
                x: 10,
                y: 12,
              },
              // {
              //   name: 'subtitle',
              //   align: 'tr',
              //   x: 15,
              //   y: 12,
              // },
              // {
              //   name: 'setting',
              //   align: 'tr',
              //   x: 15,
              //   y: 12,
              // },
              {
                name: 'volume',
                align: 'tr',
                x: 5,
                y: 10,
              },
            ],
          },
        ],
      },
      function () {
        console.log('播放器创建成功');
      }
    );
  }
};
